module.exports = __webpack_public_path__ + "media/customizations/libertyatlincoln/logo-fbd61d8c389bb7ca779ddaaeaded7ebc.png";